import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QzTrayPreviewResponse } from "../../../types/qztray/QzTrayPreviewTypes";

/**
 * 👁️ Estado global para la vista previa de tickets (QZ Tray)
 *
 * Almacena los datos generados por el backend para la previsualización del ticket:
 * - Logo, texto y QR en base64
 * - Fecha, referencia y descripción
 */
interface QzTrayPreviewState {
  preview: QzTrayPreviewResponse | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: QzTrayPreviewState = {
  preview: null,
  isLoading: false,
  error: null,
};

const qzTrayPreviewSlice = createSlice({
  name: "qzTrayPreview",
  initialState,
  reducers: {
    // 🧩 Guardar vista previa obtenida del backend
    setPreview(state, action: PayloadAction<QzTrayPreviewResponse | null>) {
      state.preview = action.payload;
      state.error = null;
    },

    // 🔄 Cambiar estado de carga
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    // ❌ Manejar errores
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    // 🧹 Reiniciar estado completo
    resetPreviewState(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { setPreview, setLoading, setError, resetPreviewState } =
  qzTrayPreviewSlice.actions;

export default qzTrayPreviewSlice.reducer;
